export const markerdata = [
	{
		title: '풀코스 출발, 도착',
		lat: 34.93824533293566,
		lng: 127.51941208098545,
	},
	{
		title: '풀 반환',
		lat: 34.84019,
		lng: 127.48477,
	},
];
